module.exports = __webpack_public_path__ + "195c6c0080477d191af5a878e25ed3cb.svg";